<div [formGroup]="form" class="flex-wrap">

    <mat-form-field redispatchProvideReadonly>
        <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_ABRECHNUNGSMODELL"
                                                 [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>Abrechnungsmodell</mat-label>
        <mat-select formControlName="abrechnungsmodell"
                    [redispatchDisableControl]="disabled || readonly"
                    data-qa="abrechnungsmodell"
                    name="abrechnung_abrechnungsmodell">
            @for (item of AbrechnungsmodelltypItems; track item.key) {
                <mat-option
                    [value]="item.key">{{ item.description }}
                </mat-option>
            }
        </mat-select>
        @if (f.abrechnungsmodell.hasError('required')) {
            <mat-error>
                Bitte wählen Sie ein Abrechnungsmodell aus
            </mat-error>
        }
    </mat-form-field>

    <mat-form-field redispatchProvideReadonly [class.hidden]="!isSpitzLight">
        <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_DATENQUELLE_SPITZ_LIGHT_MODELL"
                                                 [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>Datenquelle Spitz-Light-Modell</mat-label>
        <mat-select formControlName="datenquelleSpitzLightModell"
                    [redispatchDisableControl]="disabled || readonly"
                    data-qa="datenquelleSpitzLightModell"
                    [required]="isSpitzLight"
                    matInput
                    name="abrechnung_datenquelleSpitzLightModell">
            @for (item of DatenquelleSpitzLightItems; track item.key) {
                <mat-option
                    [value]="item.key">{{ item.description }}
                </mat-option>
            }
        </mat-select>
        @if (f.datenquelleSpitzLightModell.hasError('required')) {
            <mat-error>
                Bitte wählen Sie eine Datenquelle aus
            </mat-error>
        }
    </mat-form-field>

    <mat-form-field redispatchProvideReadonly [class.hidden]="!isWetterDl">
        <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_AUSGEWAEHLTER_WETTERDIENSTLEISTER"
                                                 [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>Ausgewählter Wetterdienstleister</mat-label>
        <input formControlName="ausgewaehlterWetterdienstleister"
               [redispatchDisableControl]="disabled || readonly"
               data-qa="ausgewaehlterWetterdienstleister"
               [required]="isWetterDl"
               matInput
               name="abrechnung_ausgewaehlterWetterdienstleister"/>
        @if (f.ausgewaehlterWetterdienstleister.hasError('required')) {
            <mat-error>
                Bitte geben Sie einen Wetterdienstleister ein
            </mat-error>
        }
    </mat-form-field>

    <mat-form-field redispatchProvideReadonly [class.hidden]="!isReferenzanlage">
        <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_ZUGEORDNETE_REFERENZANLAGE"
                                                 [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>zugeordnete Referenzanlage</mat-label>
        <input formControlName="zugeordneteReferenzanlage"
               [redispatchDisableControl]="disabled || readonly"
               data-qa="zugeordneteReferenzanlage"
               [required]="isReferenzanlage"
               matInput
               name="abrechnung_zugeordneteReferenzanlage"/>
        @if (f.zugeordneteReferenzanlage.hasError('required')) {
            <mat-error>
                Bitte geben Sie eine zugeordnete Referenzanlage ein
            </mat-error>
        }
        @if (f.zugeordneteReferenzanlage.getError('maxlength'); as error) {
            <mat-error>
                Die zugeordnete Referenzanlage ist zu lang ({{ error.requiredLength }})
            </mat-error>
        }
    </mat-form-field>

</div>
